// extracted by mini-css-extract-plugin
export default {"base":"vp_ATclZ","error":"vp_Y2Qq4"};